import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Plus } from '@phosphor-icons/react';
import { Button, Dropdown, Modal, Table } from 'app/components';
import { deleteEvent, getCitiesList, getEventList } from './api';
import { ACTION_ITEMS, COLUMN_CONFIG, STATUS_FILTER } from './constants';

const AdminEventsList = () => {
  const { cityList, eventList, filters, totalPages } = useSelector((state) => state.adminEventList);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [deletableEventId, setDeletableEventId] = useState(null); 

  useEffect(() => {
    getCitiesList();
  }, []);

  useEffect(() => {
    getEventList({ ...filters });
  }, [filters]);

  const onChangeTableData = (key, value) => {
    const filterKey = key === 'search' ? 'searchText' : key;

    if (filters?.[filterKey] !== value) {
      dispatch({
        type: 'ADMIN_EVENT_LIST:FILTERS:SET',
        data: {
          ...filters,
          [filterKey]: value,
          ...(filterKey !== 'page_no' && ({
            page_no: 1,
          })),
        },
      });
    }
  };

  const HeaderActionItems = (
    <>
      <Dropdown
        options={cityList || []}
        value={filters?.city}
        onChange={(value) => onChangeTableData('city', value)}
        label="City"
        width={250}
        placeholder="Filter City"
      />
      <Dropdown
        options={STATUS_FILTER}
        value={filters?.status}
        onChange={(value) => onChangeTableData('status', value)}
        width={250}
        label="Status"
        placeholder="Filter Status"
      />
      <Button
        size="small"
        onClick={() => navigate('/admin/event/create')}
        iconLeft={<Plus />}
      >
        Add New Event
      </Button>
    </>
  );

  const onClickActionItem = (actionItem, row) => {
    if (actionItem.action === 'edit') {
      navigate(`../admin/event/${row?._id}`)
    } else if (actionItem.action === 'delete') {
      setDeletableEventId(row?._id);
    }
  };

  const onDeleteEvent = () => {
    deleteEvent(deletableEventId, () => {
      if (filters?.page_no !== 1) onChangeTableData('page_no', 1);
      else getEventList(filters);

      setDeletableEventId(null);
    });
  };

  return (
    <div className="flex flex-col gap-4 p-5 admin-events-list">
      <Table
        totalPages={totalPages}
        showSearch={true}
        columns={COLUMN_CONFIG}
        rows={eventList}
        selectedPage={filters?.page_no}
        searchText={filters?.searchText}
        onChange={onChangeTableData}
        headerActionItems={HeaderActionItems}
        actionItems={ACTION_ITEMS}
        onClickActionItem={onClickActionItem}
      />
      <Modal
        className="delete-confirmation-modal"
        primaryText="Delete"
        size="regular"
        isOpen={!!deletableEventId}
        onClickPrimaryCta={onDeleteEvent}
        onClickSecondaryCta={() => setDeletableEventId(null)}
        title="Are you sure you want to delete this event?"
      />
    </div>
  );
};

export default AdminEventsList;
